import createClient from '../../apolloClient';
import QUERY_ESIM_LICENSES from '../../query/esimLicenses';

const fetchEsimLicenses = async (variables) => {
  const client = createClient();
  const result = await client.query({
    query: QUERY_ESIM_LICENSES,
    variables,
  });
  const { esimLicenses } = result?.data || {};
  if (!esimLicenses?.isSuccess) throw esimLicenses.message;
  return esimLicenses;
};

export default fetchEsimLicenses;
